import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { CheckCircle } from '@phosphor-icons/react';
import { GROUP_META } from './constants';

const cellClassForStatus = (status) => {
  if (status === 'success') return 'bg-emerald-500';
  if (status === 'failed') return 'bg-red-500';
  if (status === 'running' || status === 'checking') return 'bg-amber-400';
  return 'bg-slate-200';
};

const OverviewCard = ({ group, scenarios, statuses }) => {
  const meta = GROUP_META[group];
  const Icon = meta.icon;
  const groupScenarios = scenarios.filter((s) => s.group === group);
  const total = groupScenarios.length;
  const passed = groupScenarios.filter((s) => statuses[s.id] === 'success').length;
  const failed = groupScenarios.filter((s) => statuses[s.id] === 'failed').length;
  const allDone = passed === total;

  return (
    <Card
      data-testid={`overview-${group}`}
      className={`${meta.border} ${allDone ? meta.bg : ''}`}
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div
              className="p-1.5 rounded-md"
              style={{ backgroundColor: `${meta.color}15` }}
            >
              <Icon size={18} weight="duotone" style={{ color: meta.color }} />
            </div>
            <span className="font-semibold text-sm text-slate-800">{meta.label}</span>
          </div>
          {allDone && <CheckCircle size={20} weight="fill" className="text-emerald-500" />}
        </div>
        <div className="flex items-end justify-between">
          <div>
            <span className="text-2xl font-bold text-slate-900">{passed}</span>
            <span className="text-sm text-slate-400 ml-1">/ {total}</span>
          </div>
          <div className="flex gap-1">
            {groupScenarios.map((s) => (
              <div
                key={s.id}
                className={`w-3 h-3 rounded-sm ${cellClassForStatus(statuses[s.id])}`}
                title={s.label}
              />
            ))}
          </div>
        </div>
        {failed > 0 && (
          <p className="text-xs text-red-600 mt-2">
            {failed} scenario{failed > 1 ? 's' : ''} failed
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default OverviewCard;
